import React, { useState } from "react";
import { API } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  CircularProgress,
  InputAdornment,
  TextField
} from "@material-ui/core";
import { Error as ErrorIcon } from "@material-ui/icons";
import activationIcon from "../../static/images/ctv-activation-icon.svg";

const useStyles = makeStyles(theme => ({
  img: {
    width: "147px",
    marginTop: "40px"
  },
  title: {
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "36px",
    lineHeight: "45px",
    color: theme.palette.tertiary.main
  },
  form: {
    marginBottom: "50px"
  },
  p: {
    fontStyle: "normal",
    fontSize: "18px",
    fontWeight: "normal",
    lineHeight: "23px",
    textAlign: "center",
    margin: "0 auto 16px auto",
    padding: 0
  },
  input: {
    width: "300px",
    height: "50px",
    fontWeight: 600,
    fontSize: "21px",
    lineHeight: "26px",
    "& ::placeholder": {
      textTransform: "none"
    },
    "& svg": {
      fill: theme.palette.error.dark
    }
  },
  btn: {
    background: theme.palette.tertiary.main,
    width: "300px",
    height: "50px",
    fontSize: "20px",
    lineHeight: "25px",
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.tertiary.main,
      width: "300px",
      height: "50px",
      fontSize: "20px",
      lineHeight: "25px",
      color: "#fff",
      fontWeight: 600
    }
  }
}));

const CtvActivateDevicePage = props => {
  const classes = useStyles();

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const submitCode = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.put("activate", `/${code}/`, {
        queryStringParameters: {
          email: props.authProps.user.username
        },
        body: {
          refreshToken:
            props.authProps.user.signInUserSession.refreshToken.token
        }
      });
      setError("");
      setSuccess(true);
    } catch (e) {
      console.log(e.response.data);
      setError(e.response.data.error);
    }
    setLoading(false);
  };

  const showInputAdornment = () => {
    if (err.length) {
      return (
        <InputAdornment position="end">
          <ErrorIcon />
        </InputAdornment>
      );
    } else if (loading) {
      return (
        <InputAdornment position="end">
          <CircularProgress size={25} />
        </InputAdornment>
      );
    }
  };

  const resetForm = () => {
    setCode("");
    setLoading(false);
    setError("");
    setSuccess(false);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      m={1}
      p={1}
    >
      <Box mb={1} textAlign="center">
        <img
          src={activationIcon}
          alt="Device Activation"
          className={classes.img}
        />
      </Box>

      {success ? (
        <>
          <Box mb={1} textAlign="center">
            <h2 className={classes.title}>Your Device Is Activated</h2>
          </Box>
          <Box mb={1} textAlign="center">
            <Button
              onClick={resetForm}
              className={classes.btn}
              variant="contained"
              disableElevation
            >
              Activate Another Device
            </Button>
          </Box>
        </>
      ) : (
        <>
          <Box mb={1} textAlign="center">
            <h2 className={classes.title}>Activate Your Device</h2>
          </Box>
          <Box mb={1} textAlign="center">
            <p className={classes.p}>
              To activate your device, please enter the activation code shown on
              your screen.
            </p>
          </Box>
          <Box mb={1} textAlign="center">
            <form
              onSubmit={submitCode}
              noValidate
              autoComplete="off"
              className={classes.form}
            >
              <TextField
                className={classes.input}
                label="Activation Code"
                autoFocus={true}
                variant="outlined"
                name="code"
                placeholder="Enter Device Code"
                onChange={e => setCode(e.target.value.toUpperCase())}
                error={err !== ""}
                helperText={
                  err === ""
                    ? ""
                    : "The activation code you entered is invalid."
                }
                FormHelperTextProps={{
                  classes: { root: classes.errorHelperText }
                }}
                inputProps={{
                  maxLength: 6,
                  style: { textTransform: "uppercase" }
                }}
                InputProps={{
                  endAdornment: showInputAdornment()
                }}
              />
            </form>
          </Box>
          <Box mb={1} textAlign="center">
            <Button
              onClick={submitCode}
              className={classes.btn}
              variant="contained"
              disableElevation
              disabled={code.length !== 6}
            >
              Activate
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default CtvActivateDevicePage;
